"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flushMetrics = exports.addTimer = exports.reportHistogram = exports.incrementCounter = exports.reportNavigationTimerByPage = exports.reportTimerByPage = exports.incrementDauCounters = exports.incrementPublisherViewCountsByPage = exports.incrementCountsByPageAndCountry = exports.initMetrics = exports.getDeviceName = void 0;
const graphene_1 = __importStar(require("@snapchat/graphene"));
const web_1 = __importDefault(require("@snapchat/graphene/lib/config/web"));
const BrowserNetworkHandler_1 = __importDefault(require("@snapchat/graphene/lib/network/BrowserNetworkHandler"));
const web_env_1 = require("@snapchat/web-env");
const web_log_1 = require("@snapchat/web-log");
const ua_parser_js_1 = require("ua-parser-js");
const LOG_INTERVAL_MS = 5000;
const parser = new ua_parser_js_1.UAParser();
const INVALID_CHARS = /[^a-zA-Z0-9-]/g;
const DESKTOP_MIN_WIDTH = 480;
/* istanbul ignore next -- remove once tests are added */
function clientFlavor() {
    return (0, web_env_1.getWindow)()?.location.hostname.endsWith(".snapchat.com") ? "production" : "development";
}
/* istanbul ignore next -- remove once tests are added */
function getDeviceName(isMobile) {
    if (typeof isMobile !== "undefined") {
        return isMobile ? "Mobile" : "Desktop";
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (0, web_env_1.getWindow)().screen.width < DESKTOP_MIN_WIDTH ? "Mobile" : "Desktop";
}
exports.getDeviceName = getDeviceName;
let markGrafanaMetricsReady;
const grafanaMetricsReady = new Promise((resolve) => {
    markGrafanaMetricsReady = resolve;
});
/* istanbul ignore next -- remove once tests are added */
function getDeviceModel(viewMode) {
    const browser = parser.getBrowser();
    const device = parser.getDevice();
    if (device.model) {
        return sanitizeMetric(device.model);
    }
    else {
        // we're in a mobile view mode, but we don't have any device info
        if (viewMode === "Mobile")
            return "Unknown_Mobile";
        // we're in a desktop view mode, just log the browser name
        if (browser.name)
            return sanitizeMetric(browser.name);
        // we didn't have a browser name either, just return unknown
        return "Unknown_Desktop";
    }
}
function initMetrics(onInit) {
    if (graphene_1.default.isReady()) {
        return;
    }
    /* istanbul ignore next -- remove once tests are added */
    const flavor = (0, web_env_1.isRunningOnServer)() ? process.env.NODE_ENV : clientFlavor();
    // From https://github.sc-corp.net/Snapchat/web-common/tree/main/packages/graphene
    // To find logs, look for `[Metrics SDK]`
    graphene_1.default.initialize({
        networkHandler: new BrowserNetworkHandler_1.default((0, web_1.default)({
            partitionName: graphene_1.PARTITION.SNAPCHAT_WEB,
            flavor,
        })),
        // To enable debug logging, run log.getLogger("[Metrics SDK]").setLevel('debug') and reload
        debugMode: web_log_1.log.getLogger("[Metrics SDK]").getLevel() === web_log_1.levels.DEBUG,
        inactiveThresholdInSecond: 60,
        // flush all events every 20 seconds, we might want to increase this when QPS(Queries per second) goes higher
        // we also might want to batch graphene requests in service worker to reduce data loss caused by the
        // long log interval
        logTimeInterval: LOG_INTERVAL_MS,
    });
    markGrafanaMetricsReady(true);
    /* istanbul ignore next -- remove once tests are added */
    if (onInit) {
        onInit();
    }
}
exports.initMetrics = initMetrics;
/* istanbul ignore next -- remove once tests are added */
async function incrementCountsByPageAndCountry(basePrefix, pageName, counter, country) {
    await grafanaMetricsReady;
    const view = ((0, web_env_1.getWindow)()?.screen.width || 0) < DESKTOP_MIN_WIDTH ? "Mobile" : "Desktop";
    const device = getDeviceModel(view);
    const prefix = toTotalsByPagePrefix(basePrefix, pageName);
    const byViewMetric = `byView.${view}`;
    const byDeviceMetric = `byDevice.${device}`;
    const byCountry = `byCountry.${country}`;
    const byPage = prefix;
    const byView = `${prefix}.${byViewMetric}`;
    const byViewByCountry = `${prefix}.${byViewMetric}.${byCountry}`;
    const byDevice = `${prefix}.${byDeviceMetric}`;
    const byDeviceByCountry = `${prefix}.${byDeviceMetric}.${byCountry}`;
    const metricNames = [byPage, byView, byViewByCountry, byDevice, byDeviceByCountry];
    incrementForMetricNames(metricNames, counter);
}
exports.incrementCountsByPageAndCountry = incrementCountsByPageAndCountry;
/* istanbul ignore next -- remove once tests are added */
async function incrementPublisherViewCountsByPage(basePrefix, pageName, counter, publisherInfo) {
    await grafanaMetricsReady;
    const { businessProfileId, country, mutableName, publisherType } = publisherInfo;
    const sanitizedMutableName = sanitizeMetric(mutableName);
    const view = ((0, web_env_1.getWindow)()?.screen.width || 0) < DESKTOP_MIN_WIDTH ? "Mobile" : "Desktop";
    const device = getDeviceModel(view);
    const prefix = toTotalsByPagePrefix(basePrefix, pageName);
    const byViewMetric = `byView.${view}`;
    const byDeviceMetric = `byDevice.${device}`;
    const byPublisherName = `byPublisherName.${sanitizedMutableName}`;
    const byCountry = `byCountry.${country}`;
    let byViewByType;
    let byDeviceByType;
    const metricNames = [];
    if (publisherType) {
        const byType = `byType.${publisherType}`;
        byViewByType = `${prefix}.${byViewMetric}.${byType}`;
        byDeviceByType = `${prefix}.${byDeviceMetric}.${byType}`;
        metricNames.push(byViewByType, byDeviceByType);
    }
    let byBizId;
    let byViewByBizId;
    let byViewByCountryByBizId;
    let byDeviceByBizId;
    let byDeviceByCountryByBizId;
    if (businessProfileId) {
        byBizId = `byBizId.${businessProfileId}`;
        byViewByBizId = `${prefix}.${byViewMetric}.${byBizId}`;
        byViewByCountryByBizId = `${prefix}.${byViewMetric}.${byCountry}.${byBizId}`;
        byDeviceByBizId = `${prefix}.${byDeviceMetric}.${byBizId}`;
        byDeviceByCountryByBizId = `${prefix}.${byDeviceMetric}.${byCountry}.${byBizId}`;
        metricNames.push(byViewByBizId, byViewByCountryByBizId, byDeviceByBizId, byDeviceByCountryByBizId);
    }
    const byPage = prefix;
    const byView = `${prefix}.${byViewMetric}`;
    const byViewByCountry = `${prefix}.${byViewMetric}.${byCountry}`;
    const byViewByPublisherName = `${prefix}.${byViewMetric}.${byPublisherName}`;
    const byViewByCountryByPublisherName = `${prefix}.${byViewMetric}.${byCountry}.${byPublisherName}`;
    const byDevice = `${prefix}.${byDeviceMetric}`;
    const byDeviceByCountry = `${prefix}.${byDeviceMetric}.${byCountry}`;
    const byDeviceByPublisherName = `${prefix}.${byDeviceMetric}.${byPublisherName}`;
    const byDeviceCountryByPublisherName = `${prefix}.${byDeviceMetric}.${byCountry}.${byPublisherName}`;
    metricNames.push(...[
        byPage,
        byView,
        byViewByCountry,
        byViewByPublisherName,
        byViewByCountryByPublisherName,
        byDevice,
        byDeviceByCountry,
        byDeviceByPublisherName,
        byDeviceCountryByPublisherName,
    ]);
    incrementForMetricNames(metricNames, counter);
}
exports.incrementPublisherViewCountsByPage = incrementPublisherViewCountsByPage;
/* istanbul ignore next -- remove once tests are added */
async function incrementDauCounters(basePrefix, pageName, country) {
    await grafanaMetricsReady;
    const view = ((0, web_env_1.getWindow)()?.screen.width || 0) < DESKTOP_MIN_WIDTH ? "Mobile" : "Desktop";
    const device = getDeviceModel(view);
    const prefix = `${basePrefix}.DAU.byPage.${pageName}`;
    const byViewMetric = `byView.${view}`;
    const byDeviceMetric = `byDevice.${device}`;
    const byCountry = `byCountry.${country}`;
    const byPage = prefix;
    const byView = `${prefix}.${byViewMetric}`;
    const byViewByCountry = `${prefix}.${byViewMetric}.${byCountry}`;
    const byDevice = `${prefix}.${byDeviceMetric}`;
    const byDeviceByCountry = `${prefix}.${byDeviceMetric}.${byCountry}`;
    const metricNames = [byPage, byView, byViewByCountry, byDevice, byDeviceByCountry];
    incrementForMetricNames(metricNames, 1);
}
exports.incrementDauCounters = incrementDauCounters;
/* istanbul ignore next -- remove once tests are added */
async function reportTimerByPage(basePrefix, pageName, timerName, milliSeconds) {
    await grafanaMetricsReady;
    const prefix = `${basePrefix}.byPage.${pageName}.${timerName}`;
    const view = ((0, web_env_1.getWindow)()?.screen.width || 0) < DESKTOP_MIN_WIDTH ? "Mobile" : "Desktop";
    const device = getDeviceModel(view);
    const byViewMetric = `byView.${view}`;
    const byDeviceMetric = `byDevice.${device}`;
    const byPage = `${prefix}`;
    const byView = `${prefix}.${byViewMetric}`;
    const byDevice = `${prefix}.${byDeviceMetric}`;
    graphene_1.default.addTimer({ metricsName: byPage, milliSec: milliSeconds });
    graphene_1.default.addTimer({ metricsName: byView, milliSec: milliSeconds });
    graphene_1.default.addTimer({ metricsName: byDevice, milliSec: milliSeconds });
}
exports.reportTimerByPage = reportTimerByPage;
/* istanbul ignore next -- remove once tests are added */
async function reportNavigationTimerByPage(basePrefix, pageName, navigation, milliSeconds) {
    await grafanaMetricsReady;
    const prefix = `${basePrefix}.byPage.${pageName}`;
    const byNavigation = `${prefix}.byNavigation.${navigation}`;
    graphene_1.default.addTimer({ metricsName: byNavigation, milliSec: milliSeconds });
}
exports.reportNavigationTimerByPage = reportNavigationTimerByPage;
/* istanbul ignore next -- remove once tests are added */
function toTotalsByPagePrefix(basePrefix, pageName) {
    return `${basePrefix}.Totals.byPage.${pageName}`;
}
/* istanbul ignore next -- remove once tests are added */
function incrementForMetricNames(metricNames, counter = 1) {
    for (const metricsName of metricNames) {
        graphene_1.default.increment({ metricsName, value: counter });
    }
}
/* istanbul ignore next -- remove once tests are added */
async function incrementCounter(metricsName, value = 1, dimensions) {
    await grafanaMetricsReady;
    graphene_1.default.increment({ metricsName: metricsName, dimensions, value });
}
exports.incrementCounter = incrementCounter;
/* istanbul ignore next -- remove once tests are added */
async function reportHistogram(gaugeName, value, dimensions) {
    await grafanaMetricsReady;
    graphene_1.default.addHistogram({ metricsName: gaugeName, dimensions, value });
}
exports.reportHistogram = reportHistogram;
/* istanbul ignore next -- remove once tests are added */
function sanitizeMetric(metricName) {
    if (!metricName)
        return "_";
    return metricName.replace(INVALID_CHARS, "_");
}
/* istanbul ignore next -- remove once tests are added */
function addTimer({ metricsPrefix, pageName, millis, name, }) {
    if (!graphene_1.default.isReady()) {
        web_log_1.log.error(`${pageName} - Graphene not initialized`);
        return;
    }
    const metricsName = `${metricsPrefix}.byPage.${pageName}.byTimer.${name}`;
    graphene_1.default.addTimer({ metricsName, milliSec: millis });
}
exports.addTimer = addTimer;
async function flushMetrics() {
    if (graphene_1.default.isReady()) {
        return graphene_1.default.flush();
    }
    return Promise.resolve();
}
exports.flushMetrics = flushMetrics;
//# sourceMappingURL=grafana.js.map